// TODO: freeWithHosting arg is not used
export const addDomain = (
  domain,
  tld,
  suggested,
  freeWithHosting,
  authCode,
) => {
  return async (dispatch, getState, { api }) => {
    // API call
    return api.addDomain(domain, tld, suggested, authCode).then(
      (data) => {
        // DEBUG:

        // const states = ["AVAILABLE", "NO_MOVE", "MOVE", "DUPLICATE", "failure"];
        /*
        data = {
          //result: states[Math.floor(Math.random() * Math.floor(4))],
          result: "MOVE",
          forward: "",
          availability: "reserved-move"
        };
        */
        return data;
      },
      (err) => {
        return err;
      },
    );
  };
};
